<template>
	<div>
        <b-modal 
            ref="hoursRecordingModal" 
            :ok-title="$t('misc.ok')" 
            :cancel-title="$t('misc.cancel')" 
            :title="modalTitle" 
            size="lg" 
            @ok="saveAction" 
            @hidden="hidden"
            :ok-disabled="$store.state.ajax_in_progress || (!$store.getters.hasPermission(['project_hours_recording'], ['update']))"
        >
            <div class="row">
                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.date') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.date"></flat-pickr>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.discipline') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedDiscipline"
                                :options="currentDiscipline"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isDisciplineLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="name" track-by="id"
                                :selectLabel="''"
                                @search-change="onDisciplineSearch"
                                @input="updateDiscipline"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedDiscipline != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedDiscipline"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="model.discipline_id != null">
                        <div class="col-lg-4">
                            <label>{{ $t('table.drawing') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedDrawing"
                                :options="currentDrawing"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isDrawingLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="info" track-by="id"
                                :selectLabel="''"
                                @search-change="onDrawingSearch"
                                @input="updateDrawing"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedDrawing != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedDrawing"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.team') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedTeam"
                                :options="currentTeam"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isTeamLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="name" track-by="id"
                                :selectLabel="''"
                                @search-change="onTeamSearch"
                                @input="updateTeam"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedTeam != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedTeam"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="model.team_id != null">
                        <div class="col-lg-4">
                            <label>{{ $t('table.team_member') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedUser"
                                :options="currentUser"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isUserLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="fullname" track-by="id"
                                :selectLabel="''"
                                @search-change="onUserSearch"
                                @input="updateUser"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedUser != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedUser"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.change_order') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedChangeOrder"
                                :options="currentChangeOrder"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isChangeOrderLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="site_change_number" track-by="id"
                                :selectLabel="''"
                                @search-change="onChangeOrderSearch"
                                @input="updateChangeOrder"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedChangeOrder != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedChangeOrder"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.tie_in') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedTieIn"
                                :options="currentTieIn"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isTieInLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="tie_in_nr" track-by="id"
                                :selectLabel="''"
                                @search-change="onTieInSearch"
                                @input="updateTieIn"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedTieIn != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedTieIn"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.scaffolding') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedScaffolding"
                                :options="currentScaffolding"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isScaffoldingLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="request_no" track-by="id"
                                :selectLabel="''"
                                @search-change="onScaffoldingSearch"
                                @input="updateScaffolding"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedScaffolding != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedScaffolding"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.punchlist') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedPunchlist"
                                :options="currentPunchlist"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isPunchlistLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="punch_no" track-by="id"
                                :selectLabel="''"
                                @search-change="onPunchlistSearch"
                                @input="updatePunchlist"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedPunchlist != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedPunchlist"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.work_type') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedWorkType"
                                :options="currentWorkType"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isWorkTypeLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="value" track-by="id"
                                :selectLabel="''"
                                @search-change="onWorkTypeSearch"
                                @input="updateWorkType"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedWorkType != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedWorkType"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.pressure_test') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedPressureTest"
                                :options="currentPressureTest"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isPressureTestLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="test_circuit_no" track-by="id"
                                :selectLabel="''"
                                @search-change="onPressureTestSearch"
                                @input="updatePressureTest"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedPressureTest != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedPressureTest"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.hours_no') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==2) return false;" class="form-control" v-model="model.hours_no" min="1" max="12">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.start_time') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="time" class="form-control" step="900" placeholder="" v-model="model.start_time">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.end_time') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="time" class="form-control" step="900" placeholder="" v-model="model.end_time">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.others') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea rows="6" maxlength="5000" class="form-control" v-model="model.others"></textarea>
                        </div>
                    </div>

                    <div class="row mb-2" v-if="specialInputs[0]">
                        <div class="col-lg-4">
                            <label>{{ $t('table.holiday') }}</label>
                        </div>
                        <div class="col-lg-4">
                            <toggle-button v-model="model.holiday" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}" :color="{checked: '#ff471a'}" @input="updateHoliday($event, 0)"/>
                        </div>
                    </div>

                    <div class="row mb-2" v-if="specialInputs[1]">
                        <div class="col-lg-4">
                            <label>{{ $t('table.sick') }}</label>
                        </div>
                        <div class="col-lg-4">
                            <toggle-button v-model="model.sick" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}" :color="{checked: '#ff471a'}" @input="updateSickLeave($event, 1)"/>
                        </div>
                    </div>
                    
                    <div class="row mb-2" v-if="specialInputs[2]">
                        <div class="col-lg-4">
                            <label>{{ $t('table.time_access') }}</label>
                        </div>
                        <div class="col-lg-4">
                            <toggle-button v-model="model.time_access" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}" :color="{checked: '#ff471a'}" @input="updateTimeAccess($event, 2)"/>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
	</div>
</template>

<script>
import Vue from 'vue';
import http from '@/libs/http';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import * as notificationIcons from '@/components/global/miscellaneous/notificationIcons.js';
import miniToastr from 'mini-toastr';
import Multiselect from 'vue-multiselect';

export default {
	name: 'HoursRecordingModal',
	components: {
		flatPickr,
		notificationIcons,
		Multiselect
	},
	props: {
        tableName: {
            type: String,
            required: true,
        },
		modalTitle: {
			type: String,
			default: ''
		},
		tableNameTranslated: {
            default: ''
        },
		isEdit: {
            type: Boolean,
            required: true,
        },
		isAdd: {
            type: Boolean,
            default: false,
        },
		model: {
			type: Object,
			default: () => ({
                id: null,
                discipline_id: null,
                team_id: null,
                drawing_id: null,
                user_id: null,
                fullname: null,
                change_order_id: null,
                tie_in_id: null,
                scaffolding_id: null,
                punchlist_id: null,
                project_setting_id: null,
                pressure_test_id: null,
                hours_no: null,
                date: null,
                start_time: null,
                end_time: null,
                others: null
			})
		}
	},
	data() {
		return {
            specialInputs: [true, true, true],

			selectedDiscipline: null,
            currentDiscipline: [],
            isDisciplineLoading: false,

            selectedDrawing: null,
            currentDrawing: [],
            isDrawingLoading: false,

            selectedTeam: null,
            currentTeam: [],
            isTeamLoading: false,

            selectedUser: null,
            currentUser: [],
            isUserLoading: false,

            selectedChangeOrder: null,
            currentChangeOrder: [],
            isChangeOrderLoading: false,

            selectedTieIn: null,
            currentTieIn: [],
            isTieInLoading: false,

            selectedScaffolding: null,
            currentScaffolding: [],
            isScaffoldingLoading: false,

            selectedPunchlist: null,
            currentPunchlist: [],
            isPunchlistLoading: false,

            selectedWorkType: null,
            currentWorkType: [],
            isWorkTypeLoading: false,

            selectedPressureTest: null,
            currentPressureTest: [],
            isPressureTestLoading: false,
		}
	},
	methods: {
        successMsg(msg) {
			miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
		},
		errorMsg(msg) {
			miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
		},
		saveAction (e) {
            e.preventDefault();
            
            let put_data = {
                project_id:         this.$route.params.id,
                discipline_id:      this.model.discipline_id,
                drawing_id:         this.model.drawing_id,
                team_id:            this.model.team_id,
                user_id:            this.model.user_id,
                change_order_id:    this.model.change_order_id,
                tie_in_id:          this.model.tie_in_id,
                scaffolding_id:     this.model.scaffolding_id,
                punchlist_id:       this.model.punchlist_id,
                project_setting_id: this.model.project_setting_id,
                pressure_test_id:   this.model.pressure_test_id,
                hours_no:           this.model.hours_no,
                date:               this.model.date,
                start_time:         this.model.start_time,
                end_time:           this.model.end_time,
                holiday:            this.model.holiday,
                sick:               this.model.sick,
                time_access:        this.model.time_access,
                others:             this.model.others,
            }

            Object.keys(put_data).forEach(key => {
                if (put_data[key] === '') {
                    put_data[key] = null;
                }
            });
            
            if (this.isEdit) {
                put_data['id'] = this.model.id;
                let data = http.route(this.tableName + '/' + this.model.id).patch(put_data, true);
                data.then(response => {
                    if (response.isError == false) {
                        this.$refs.hoursRecordingModal.hide();
                        this.$emit('onLoadTable');
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    }
                });
            } else if (!this.isEdit) {
                let data = http.route(this.tableName).post(put_data, true);
                data.then(response => {
                    if (response.isError == false) {
                        this.$refs.hoursRecordingModal.hide();
                        this.$emit('onLoadTable');
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.created'));
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    }
                });
            }
        },
        clearAll () {
            this.selectedDiscipline       = null;
            this.selectedDrawing          = null;
            this.selectedTeam             = null;
            this.selectedUser             = null;
            this.selectedChangeOrder      = null;
            this.selectedTieIn            = null;
            this.selectedScaffolding      = null;
            this.selectedPunchlist        = null;
            this.selectedWorkType         = null;
            this.selectedPressureTest     = null;

            this.currentDiscipline        = [];
            this.currentDrawing           = [];
            this.currentTeam              = [];
            this.currentUser              = [];
            this.currentChangeOrder       = [];
            this.currentTieIn             = [];
            this.currentScaffolding       = [];
            this.currentPunchlist         = [];
            this.currentWorkType          = [];
            this.currentPressureTest      = [];

            this.model.discipline_id      = null;
            this.model.drawing_id         = null;
            this.model.team_id            = null;
            this.model.user_id            = null;
            this.model.change_order_id    = null;
            this.model.tie_in_id          = null;
            this.model.scaffolding_id     = null;
            this.model.punchlist_id       = null;
            this.model.project_setting_id = null;
            this.model.pressure_test_id   = null;
            this.model.hours_no           = null;
            this.model.start_time         = null;
            this.model.end_time           = null;
            this.model.others             = null;
            this.model.holiday            = null;
            this.model.sick               = null;
            this.model.time_access        = null;
        },
        show() {
			this.$refs.hoursRecordingModal.show();
		},
        hidden() {
            this.$emit('hidden');
            this.clearAll();
        },
        hideOthers (to_ignore, showAll = false) {
            for (let i = 0; i < 3; i++) {
                if (showAll == false){
                    Vue.set(this.specialInputs, i, true);
                } else if(showAll && to_ignore == i) {
                    Vue.set(this.specialInputs, i, true);
                } else {
                    Vue.set(this.specialInputs, i, false);
                }
            }
        },
        updateHoliday(event, id) {
            this.hideOthers(id, event);
        },
        updateSickLeave(event, id) {
            this.hideOthers(id, event);
        },
        updateTimeAccess(event, id) {
            this.hideOthers(id, event);
        },
        onDisciplineSearch(search) {
            if (search == '') {
                this.currentDiscipline = [];
                
                return false;
            }
            
            this.isDisciplineLoading = true;
            this.searchDiscipline(search, this);
        },
        searchDiscipline: _.debounce((search, vm) => {
            let data = http.route('discipline?project_id='+vm.$route.params.id+'&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentDiscipline = response.data;
                }
                vm.isDisciplineLoading = false;
            });
        }, 500),
        updateDiscipline(discipline) {
            this.currentDrawing = [];
            this.selectedDrawing = null;
            this.model.drawing_id = null;

            if (discipline == null) {
                this.model.discipline_id = null;
            } else {
                this.model.discipline_id = discipline.id;
                http.route('drawing?project_id=' + this.$route.params.id + '&filters[parent_drawing_id]=null&filters[discipline_id]='+discipline.id).get().then(response => {
                    if (response.data != false) {
                        this.currentDrawing = response.data;
                    }
                });
            }
        },
        clearSelectedDiscipline () {
            this.selectedDiscipline  = null;
            this.model.discipline_id = null;
        },
        onDrawingSearch(search) {
            if (search == '') {
                this.currentDrawing = [];
                
                return false;
            }

            if (this.model.discipline_id != null) {
                this.isDrawingLoading = true;
                this.searchDrawing(search, this);
            }
        },
        searchDrawing: _.debounce((search, vm) => {
            var data = null;
            switch(vm.model.discipline_id) {
                case 7:
                    data = http.route('drawing?get_all=1&project_id='+vm.$route.params.id+'&search_select=' + search + '&filters[show_painting]=1').get();
                    break;
                case 8:
                    data = http.route('drawing?get_all=1&project_id='+vm.$route.params.id+'&search_select=' + search + '&filters[show_insulation]=1').get();
                    break;
                default:
                    data = http.route('drawing?project_id='+vm.$route.params.id+'&filters[parent_drawing_id]=null&filters[discipline_id]=' + vm.model.discipline_id + '&search_select=' + search).get();
                    break;
            }
            data.then(response => {
                if (response.data != false) {
                    vm.currentDrawing = response.data;
                }
                vm.isDrawingLoading = false;
            });
        }, 500),
        updateDrawing(drawing) {
            this.model.drawing_id = (drawing != null) ? drawing.id : null;
        },
        clearSelectedDrawing () {
            this.selectedDrawing  = null;
            this.model.drawing_id = null;
        },
        onTeamSearch(search) {
            if (search == '') {
                this.currentTeam = [];
                
                return false;
            }

            this.isTeamLoading = true;
            this.searchTeam(search, this);
        },
        searchTeam: _.debounce((search, vm) => {
            // let data = http.route('team?project_id='+vm.$route.params.id+'&search_select=' + search + '&filters[team_leader_id]=' + vm.$store.state.user.user.id).get();
            let data = http.route('team?project_id='+vm.$route.params.id+'&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentTeam = response.data; 
                }
                vm.isTeamLoading = false;
            });
        }, 500),
        updateTeam(team) {
            this.selectedUser = null;
            this.currentUser = [];
            this.model.team_id = (team != null) ? team.id : null;
            if (this.model.team_id == null && this.isEdit && !this.isAdd) {
                this.model.user_id = null;
            }

            if(team != null) {
                http.route('team/' + team.id +'/members?project_id='+this.$route.params.id).get().then(response => {
                    if (response.data != false) {
                        this.selectedUser = null;
                        this.currentUser  = response.data;
                    }
                });
            }
        },
        clearSelectedTeam () {
            this.selectedTeam  = null;
            this.model.team_id = null;
            this.clearSelectedUser();
        },
        onUserSearch(search) {
            if (search == '') {
                this.currentUser = [];
                
                return false;
            }

            if (this.model.team_id != null) {
                this.isUserLoading = true;
                this.searchUser(search, this);
            }
        },
        searchUser: _.debounce((search, vm) => {
            let data = http.route('team/' + vm.model.team_id +'/members?project_id='+vm.$route.params.id+'&get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentUser = response.data;
                }
                vm.isUserLoading = false;
            });
        }, 500),
        updateUser(user) {
            this.model.user_id = (user != null) ? user.user_id : null;
        },
        clearSelectedUser () {
            this.selectedUser  = null;
            this.model.user_id = null;
        },
        onChangeOrderSearch(search) {
            if (search == '') {
                this.currentChangeOrder = [];
                
                return false;
            }

            this.isChangeOrderLoading = true;
            this.searchChangeOrder(search, this);
        },
        searchChangeOrder: _.debounce((search, vm) => {
            let data = http.route('change_order?project_id=' + vm.$route.params.id + '&filters[parent_change_order_id]=null&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentChangeOrder = response.data;
                }
                vm.isChangeOrderLoading = false;
            });
        }, 500),
        updateChangeOrder(change_order) {
            this.model.change_order_id = (change_order != null) ? change_order.id : null;
        },
        clearSelectedChangeOrder () {
            this.selectedChangeOrder   = null;
            this.model.change_order_id = null;
        },
        onTieInSearch(search) {
            if (search == '') {
                this.currentTieIn = [];
                
                return false;
            }

            this.isTieInLoading = true;
            this.searchTieIn(search, this);
        },
        searchTieIn: _.debounce((search, vm) => {
            let data = http.route('tie_in?project_id=' + vm.$route.params.id + '&filters[parent_tie_in_id]=null&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentTieIn = response.data;
                }
                vm.isTieInLoading = false;
            });
        }, 500),
        updateTieIn(tie_in) {
            this.model.tie_in_id = (tie_in != null) ? tie_in.id : null;
        },
        clearSelectedTieIn () {
            this.selectedTieIn   = null;
            this.model.tie_in_id = null;
        },
        onScaffoldingSearch(search) {
            if (search == '') {
                this.currentScaffolding = [];
                
                return false;
            }

            this.isScaffoldingLoading = true;
            this.searchScaffolding(search, this);
        },
        searchScaffolding: _.debounce((search, vm) => {
            let data = http.route('scaffolding?project_id=' + vm.$route.params.id + '&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentScaffolding = response.data;
                }
                vm.isScaffoldingLoading = false;
            });
        }, 500),
        updateScaffolding(scaffolding) {
            this.model.scaffolding_id = (scaffolding != null) ? scaffolding.id : null;
        },
        clearSelectedScaffolding () {
            this.selectedScaffolding  = null;
            this.model.scaffolding_id = null;
        },
        onPunchlistSearch(search) {
            if (search == '') {
                this.currentPunchlist = [];
                
                return false;
            }

            this.isPunchlistLoading = true;
            this.searchPunchlist(search, this);
        },
        searchPunchlist: _.debounce((search, vm) => {
            let data = http.route('punchlist?project_id=' + vm.$route.params.id + '&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentPunchlist = response.data;
                }
                vm.isPunchlistLoading = false;
            });
        }, 500),
        updatePunchlist(punchlist) {
            this.model.punchlist_id = (punchlist != null) ? punchlist.id : null;
        },
        clearSelectedPunchlist () {
            this.selectedPunchlist  = null;
            this.model.punchlist_id = null;
        },
        onWorkTypeSearch(search) {
            if (search == '') {
                this.currentWorkType = [];
                
                return false;
            }

            this.isWorkTypeLoading = true;
            this.searchWorkType(search, this);
		},
		searchWorkType: _.debounce((search, vm) => {
            http.route("projectsetting?project_id="+vm.$route.params.id+"&filters[type]=work_type&get_all=1&search_select=" + search).get()
            .then(response => {
                if (response.data != false) {
                    vm.currentWorkType = response.data;
                }
                vm.isWorkTypeLoading = false;
            });
		}, 500),
		updateWorkType(work_type) {
			this.model.project_setting_id = (work_type != null) ? work_type.id : null;
		},
        clearSelectedWorkType () {
            this.selectedWorkType   = null;
            this.model.work_type_id = null;
        },
        onPressureTestSearch(search) {
            if (search == '') {
                this.currentPressureTest = [];
                
                return false;
            }

            this.isPressureTestLoading = true;
            this.searchPressureTest(search, this);
		},
		searchPressureTest: _.debounce((search, vm) => {
            http.route("pressuretest?project_id="+vm.$route.params.id+"&filters[parent_pressure_test_id]=null&get_all=1&search_select=" + search).get()
            .then(response => {
                if (response.data != false) {
                    vm.currentPressureTest = response.data;
                }
                vm.isPressureTestLoading = false;
            });
		}, 500),
		updatePressureTest(pressure_test) {
			this.model.pressure_test_id = (pressure_test != null) ? pressure_test.id : null;
		},
        clearSelectedPressureTest () {
            this.selectedPressureTest   = null;
            this.model.pressure_test_id = null;
        },
	}
}
</script>

<style scoped>
    select {
        -webkit-appearance:menulist-button;
        -moz-appearance:menulist-button;
    }
</style>


// WEBPACK FOOTER //
// src/components/global/modals/HoursRecordingModal.vue